import React from 'react';
import { Box, Typography } from '@mui/material';
import { SparkTruncatedTypography } from 'sharedComponents/UI';

interface Props {
  appIconSrc?: string;
  children?: React.ReactNode;
  label: string;
  referenceValue: string | null;
  isInvalid?: boolean;
  resource: string | null;
  element?: any;
  errorLabel: string | null;
  stepSortOrder: number | null;
}

const ICON_SIZE = 16;

export const MappedFieldPill = ({
  appIconSrc,
  children,
  label,
  isInvalid,
  referenceValue,
  resource: resourceLabel,
  errorLabel,
  stepSortOrder,
}: Props) => {
  const isReferenceUndefined = errorLabel === 'referenceUndefined';

  return (
    <Box
      sx={{
        alignItems: 'center',
        borderRadius: 1,
        border: '1px solid transparent',
        display: 'inline-flex',
        gap: 1,
        height: 'auto',
        margin: 0.5,
        padding: '2px 5px',
        userSelect: 'none',
        verticalAlign: 'bottom',
        '&[data-selected]': {
          boxShadow: isInvalid
            ? '0 0 0 2px var(--color-orange-warning)'
            : '0 0 0 2px #6267ac',
          outline: 'none',
        },
        borderColor:
          isInvalid || !!errorLabel ? 'var(--color-orange-warning)' : '#6267ac',
      }}
      component='span'
    >
      {children}
      {isInvalid && isReferenceUndefined && (
        <Box component='span' display='flex' alignItems='baseline'>
          <Typography
            component='span'
            sx={{
              color: '#000000de',
              overflowWrap: 'break-word',
              fontSize: '14px',
            }}
          >
            {label}
          </Typography>
        </Box>
      )}
      {appIconSrc && (
        <Box
          component='img'
          alt=''
          src={appIconSrc}
          sx={{
            display: 'inline-block',
            verticalAlign: 'middle',
          }}
          style={{
            height: ICON_SIZE,
            width: ICON_SIZE,
          }}
        />
      )}

      <Box
        component='span'
        display='flex'
        alignItems='baseline'
        marginTop={0.1}
      >
        {stepSortOrder && isReferenceUndefined && (
          <Typography
            component='span'
            sx={{
              color: '#000000de',
              overflowWrap: 'break-word',
              fontSize: '14px',
              fontFamily: 'Mont-Semibold',
              paddingRight: 0.3,
            }}
          >
            {stepSortOrder}
          </Typography>
        )}
        {resourceLabel && !isReferenceUndefined ? (
          <Typography
            component='span'
            sx={{
              color: '#000000de',
              overflowWrap: 'break-word',
              fontSize: '14px',
              fontFamily: 'Mont-Semibold',
            }}
          >
            {resourceLabel}
          </Typography>
        ) : (
          !isReferenceUndefined && (
            <Typography
              component='span'
              sx={{
                color: '#000000de',
                overflowWrap: 'break-word',
                fontSize: '14px',
              }}
            >
              {errorLabel}
            </Typography>
          )
        )}
        {!!resourceLabel && !isReferenceUndefined && !!referenceValue && (
          <>: </>
        )}
        {!!referenceValue && !isInvalid && (
          <SparkTruncatedTypography
            typographyProps={{
              sx: {
                overflowWrap: 'break-word',
                fontSize: '14px',
              },
              component: 'span',
            }}
            boxStyles={{ width: 'inherit' }}
          >
            {referenceValue}
          </SparkTruncatedTypography>
        )}
      </Box>
    </Box>
  );
};
